import { parse } from 'date-fns';

const isDate18orMoreYearsOld = (day, month, year) => {
  return parse(`${year+18} ${month} ${day}`, 'yyyy M d', new Date()) <= new Date();
}

const years = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i)

const months = new Array(12).fill(0).map((_, i) => {
  return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(`${new Date().getYear()}/${i + 1}/1`))
})

export { isDate18orMoreYearsOld, years, months }
